import { render, staticRenderFns } from "./HeaderBread.vue?vue&type=template&id=1124f8f9&scoped=true"
import script from "./HeaderBread.vue?vue&type=script&lang=js"
export * from "./HeaderBread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1124f8f9",
  null
  
)

export default component.exports